var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.update($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }